import * as amplitude from "@amplitude/analytics-browser";
import { Checkbox, Dropdown, Menu } from "antd";
import { isDev } from "../../../utils";
import { BankFeedAccountLinkingData } from "../constants";
import { GenericBankFeedsAccountName } from "../GenericBankFeedsAccountName";

export const getMessageFromError = (err: any) => {
  return err.response?.data?.error_message ?? err.message;
};

export const trackAmplitudeEvent = (
  event: string,
  props?: Record<string, any>,
) => {
  const message = `Bank Feeds Link: ${event}${event.endsWith(".") ? "" : "."}`;
  if (isDev()) {
    console.log({ message, props });
  }
  amplitude.track(message, props);
};

export const getFormattedBankFeedAccounts = (
  confirmedBankFeedAccountLinkingData: BankFeedAccountLinkingData[],
) => {
  const elements = confirmedBankFeedAccountLinkingData.map(
    (linkingData: any) => {
      return (
        <div
          key={linkingData.bfAccountId}
          className="py-4 mt-1 flex items-center border-gray-300"
          style={{
            flex: "1 0 100%",
            border: "1px solid rgba(42, 47, 69, .17)",
            borderRadius: "15px",
            height: "45px",
          }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%", // full width container
              padding: "10px",
            }}>
            <Checkbox
              id={linkingData.bfAccountId}
              className="ml-3"
              disabled={true}
              checked={true}
              style={{ marginLeft: 0 }}></Checkbox>
            <div>
              <div
                className="ml-3"
                style={{
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  width: "250px",
                }}>
                <GenericBankFeedsAccountName
                  id={linkingData.bfAccountId}
                  text={linkingData.bfAccountName}
                  width="240px"
                />
              </div>
            </div>
            <div style={{ marginLeft: "auto" }}>
              <Dropdown overlay={<Menu />} disabled={true}>
                <a
                  onClick={(e) => e.preventDefault()}
                  style={{
                    outline: "1px solid #d3d3d3",
                    outlineOffset: 2,
                    borderRadius: 4,
                    padding: "2px 8px",
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "170px",
                    fontSize: 12,
                  }}>
                  <GenericBankFeedsAccountName
                    id={"selected_" + linkingData.bfAccountId}
                    text={linkingData.glAccountName}
                    width="160px"
                  />
                </a>
              </Dropdown>
            </div>
          </div>
        </div>
      );
    },
  );

  return elements;
};
